import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';
import { ExpeditionStatusEnum, LadenFactorExpeditionOutDTO } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
  ladenFactorExpeditions?: LadenFactorExpeditionOutDTO[]
}

const OrderedExpeditionsBadge: React.FC<ComponentProps> = ({ ladenFactorExpeditions }) => {
  const { tr } = useTranslationLgs();

  const activeExpeditions = ladenFactorExpeditions?.filter(expedition => expedition.expeditionStatus !== ExpeditionStatusEnum.CANCELED) || [];
  const expeditionCount = activeExpeditions.length;
  const manipulationUnits = activeExpeditions.reduce((sum, expedition) => sum + (expedition.manipulationUnits || 0), 0);
  return (
    <>
      {isNotNullOrUndefined(expeditionCount) && (
        <Badge filled={false} value={tr(`OrderedExpeditionsBadge.value`, `{{expeditionCount}} expeditions | {{manipulationUnits}} MU`, {expeditionCount: expeditionCount, manipulationUnits: manipulationUnits})} highlightedValue={false} label={tr(`OrderedExpeditionsBadge.totalOrder`, `Ordered`)}></Badge>
      )}
    </>
  );
};

export default OrderedExpeditionsBadge;
